module.exports = __webpack_public_path__ + "static/media/SFH17_spinned.5ba97634.png";